<template>
    <div>
        <h6 style="font-weight: bold">{{ title }}</h6>

        <b-table :items="collis" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" fixed outlined>
            <template v-slot:head(barcode) >{{ $t('history.label.AWB') }}</template>

            <template v-slot:head(packageType)>{{ $t('history.label.Type') }}</template>

            <template v-slot:head(weight)>{{ $t('history.label.Weight') }}</template>

            <template v-slot:head(length)>{{ $t('history.label.Length') }}</template>

            <template v-slot:head(width)>{{ $t('history.label.Width') }}</template>

            <template v-slot:head(height)>{{ $t('history.label.Height') }}</template>
          
            <template v-slot:head(status)>{{ $t('history.label.DeliveryStatus') }}</template>

          <template v-slot:head(latestTerminalScanDateTime)>
            {{ allValuesNull('latestTerminalScanDateTime') ? '' : $t('Scan Time') }}
          </template>
          
           <template v-slot:cell(status)="data">
                {{ data.item.delivered !== null && data.item.delivered == true ? $t('history.label.Delivered') :
                $t('history.label.' + data.item.status)
                }}
            </template>

            <template v-slot:cell(barcode)="data">
                <a v-if="isQuote">{{ data.item.barcode }}</a>
                <a v-else
                   :href="data.item.trackingLink"
                   target="_blank"
                >{{ data.item.barcode }}</a>
            </template>
            <template v-slot:cell(image)="data">
              <a v-if="data.item.imageUrl != null" :href="data.item.imageUrl" target="_blank">
                <font-awesome-icon icon="arrow-circle-right" title="click to see image" size="lg"/>
              </a>
            </template>

        </b-table>
    </div>
</template>
<script>
  import localization from '@/mixins/localizationMixin';
  export default {
      components: {},

      mixins: [localization],

      props: {
          collis: { type: Array, required: true },
          title: { type: String, required: true },
          isQuote: {type: Boolean, required: true}
      },

      data() {
          return {
              sortBy: 'barcode',
              sortDesc: false,
              fields: [
                  { key: 'packageType', sortable: false },
                  {
                      key: 'weight',
                      sortable: false,
                      formatter: (value) => this.localizedNumber(value),
                  },
                  {
                      key: 'length',
                      sortable: false,
                      formatter: (value) => this.localizedNumber(value),
                  },
                  {
                      key: 'width',
                      sortable: false,
                      formatter: (value) => this.localizedNumber(value),
                  },
                  {
                      key: 'height',
                      sortable: false,
                      formatter: (value) => this.localizedNumber(value),
                  },
                  { key: 'barcode', sortable: false },
                  { key: ' ', sortable: false },
                  { key: 'image', sortable: false },
                {
                      key: 'latestTerminalScanDateTime',
                      sortable: false,
                    formatter: (value) => value ? this.formatDateTimeOffset(value) : ''                  },
                  { key: 'status', sortable: false },
              ],
          };
      },


    methods: {
      allValuesNull(key) {
        return this.collis.every(item => item[key] === null);
      }
    },
  };
</script>

<style></style>
